import axios from "../../Shared/auth-header";
import { toast } from "react-toastify";
import _ from "lodash";
export default {
  GetAllNotifications: async () => {
    let url = `api/NotificationModule/AllModulesWithDetails`;

    var { data } = await axios.get(url);
    if (data && data.statusCode == 200) {
      if (!_.isEmpty(data.result)) {
        return data.result;
      } else {
        return null;
      }
    } else {
      toast.error(data.message);
      return null;
    }
  },
  GetRecipients: async () => {
    let url = `api/Permission/NotificationRecipients`;

    var { data } = await axios.get(url);
    if (data && data.statusCode == 200) {
      if (!_.isEmpty(data.result)) {
        return data.result;
      } else {
        return null;
      }
    } else {
      toast.error(data.message);
      return null;
    }
  },
  GetTriggersByMemberId: async (memberId) => {
    let url = `api/NotificationModule/TriggersByMemberId?memberId=${memberId}`;

    var { data } = await axios.get(url);
    if (data && data.statusCode == 200) {
      if (!_.isEmpty(data.result)) {
        return data.result;
      } else {
        return null;
      }
    } else {
      toast.error(data.message);
      return null;
    }
  },
  GetRecipientsByTriggerId: async (triggerId) => {
    let url = `/api/NotificationModule/RecipientsByTriggerId?triggerId=${triggerId}`;

    var { data } = await axios.get(url);
    if (data && data.statusCode == 200) {
      if (!_.isEmpty(data.result)) {
        return data.result;
      } else {
        return null;
      }
    } else {
      toast.error(data.message);
      return null;
    }
  },
  CreatOrUpdateRecipients: async (obj) => {
    let url = `api/NotificationModule/ChangeRecipientsOfTrigger`;

    var { data } = await axios.post(url, obj);
    if (data && data.statusCode == 200) {
      return true;
    } else {
      toast.error(data.message);
      return null;
    }
  },
  ChangeModuleActiveStatus: async (obj) => {
    let url = `api/NotificationModule/ChangeRecipientsOfTrigger`;

    var { data } = await axios.post(url, obj);
    if (data && data.statusCode == 200) {
      return true;
    } else {
      toast.error(data.message);
      return null;
    }
  },
  ChangeTriggerActiveStatus: async (obj) => {
    let url = `api/NotificationModule/ChangeRecipientsOfTrigger`;

    var { data } = await axios.post(url, obj);
    if (data && data.statusCode == 200) {
      return true;
    } else {
      toast.error(data.message);
      return null;
    }
  },

  updateModuleStatus: async (id, status) => {
    try {
      var { data } = await axios.put(`api/NotificationModule/ModuleStatus`, {
        id,
        status,
      });

      if (data && data.statusCode == 200) {
        toast.success(data.message);
        return true;
      } else {
        toast.error(data.message);
        return null;
      }
    } catch (error) {
      console.log(error);
    }
  },

  updateTriggerStatus: async (id, status) => {
    try {
      var { data } = await axios.put(`api/NotificationModule/TriggerStatus`, {
        id,
        status,
      });

      if (data && data.statusCode == 200) {
        toast.success(data.message);
        return true;
      } else {
        toast.error(data.message);
        return null;
      }
    } catch (error) {
      console.log(error);
    }
  },
};
